export default __webpack_public_path__ + "d774759b467e80d730ceb9a316f5737b.svg";